// /settings/theme (PRD §9.9, B6 PR1 / B6a).

import { createFileRoute } from '@tanstack/react-router';

import { ThemePage } from '../components/ThemePage';

export const Route = createFileRoute('/settings/theme')({
  component: ThemeRoute,
});

function ThemeRoute(): React.JSX.Element {
  return <ThemePage />;
}
